import getCardImageService from '../services/components/getcardimage.jsx'


const getState = (cardImageState) => ({ type: "CARD_IMAGE_STATE", cardImageState })


export const getCardImageAction = (programId) => dispatch => {
    let state = []
    getCardImageService((data, msg) => {
        if (msg === "success") {
            state = {
                message: "Success",
                status: 200,
                body: data
            }
        }
        else if (msg === "emptyBody") {
            
            state = {
                message: "Empty Body",
                status: 204,
                body: data
            }
        }
        else {
            state = data
        }
        dispatch(getState(state))
    }, programId)
}
export const clearCardImageAction = () => dispatch => {
    
    
  
    let state = {
        status: 204,
        body:{}
    }
    dispatch(getState(state))
}





// WEBPACK FOOTER //
// ./src/actions/getcardimageaction.jsx